import gql from 'graphql-tag';

import { EVENT_FRAGMENT } from '../../fragments/event.fragment';

export const RE_DATE_EVENT_ACTIVITIES = gql`
  mutation ReDateEventActivities($input: ReDateEventsInput!) {
    dealActivity {
      result: reDateEvents(input: $input) {
        error
        success
        list {
          __typename
          ...EventFields
        }
      }
    }
  }
  ${EVENT_FRAGMENT}
`;
